import {combineReducers} from 'redux';
import {products} from './products';
import {filters} from "./filters";
import {app} from "./app";

const rootReducer = combineReducers({
    products,
    filters,
    app,
});

export default rootReducer;